<template>
  <div>

    <data-table
        title="Sharers"
        table-ref="telcotable"
        icon="fa fa-users"
        :url="'/licensees/site/' + siteData.id + (this.telcoId ? '/licensee/' + this.telcoId : '')"
        :fields="fields"
        :options="siteData"
        :add-props="noAdd ? null : addPropsData"
        :add-action="noAdd ? null : action"
        :showSearch="false"
        detail-component="lic-detail-row" />
    </div>
</template>


<script>

import Vue from 'vue'

import SiteMixins from '@/mixins/SiteMixins'

import EquipAction from '@/components/actions/EquipAction'
import SharerAction from '@/components/actions/SharerAction'

import LicenseeDetails from '@/components/sites/sharers/LicenseeDetails'
import LicenseeControls from '@/components/sites/sharers/LicenseeControls'

Vue.component('lic-controls', LicenseeControls)
Vue.component('lic-detail-row', LicenseeDetails)

export default {
  mixins: [SiteMixins],

  components: {
    EquipAction,
    SharerAction,
    LicenseeControls
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    noAdd: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    // Sub-tab deep-link slug. Accepted but NOT forwarded to LicenseeDetails
    // because data-table (vuetable-2) only passes rowData + a static options
    // object to its detail-row component — there is no dynamic slot for extra
    // props. LicenseeDetails sub-tab deep-linking requires migrating
    // SiteSharers to xolas-table + LayerHost first (XOL-209 consumer matrix
    // PR 5). Tracked as a gap in docs/UX-architecture/components/tables/SitesTable.md.
    subtab: {
      type: String,
      default: null
    }

  },

  methods: {
    formatSharerStatus (value) {
      let color = 'text-primary'

      if (value === 'Terminated') {
        color = 'text-danger'
      }

      return '<b class="' + color + '">' + value + '</b>'
    }
  },

  data () {
    return {

      action: SharerAction,
      addPropsData: {
        rowData: this.rowData,
        editMode: false,
        readOnly: this.readOnly,
        noAdd: this.noAdd,
        siteId: this.rowData.id
      },

      telcoId: this.isTelco() ? Number(this.org().id) : null,

      siteData: this.rowData,

      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'status',
          title: 'Status',
          sortfield: 'status',
          callback: this.formatSharerStatus
        },
        {
          name: 'organisation.name',
          title: 'Telco',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'organisation.shortName',
          title: 'Telco',
          titleClass: 'hidden-md-and-up',
          dataClass: 'hidden-md-and-up'
        },
        {
          name: 'telcoSiteId',
          title: 'Site ID',
          sortField: 'telcoSiteId'
        },
        {
          title: 'Service',
          name: 'serviceType',
          sortField: 'serviceType',
        },
        {
          title: 'Spectrum',
          name: 'spectrumBand',
          sortField: 'spectrumBand',
        },
        {
          name: 'started',
          title: 'Started',
          sortField: 'started',
          callback: 'formatDate|D MMM YYYY',
        },
        {
          name: 'expiry',
          title: 'Expiry',
          sortField: 'expiry',
          callback: 'formatDate|D MMM YYYY',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: '__component:lic-controls',
          title: '',
          visible: !this.readOnly
        }
      ]

    }
  },

  mounted () {
//    console.log('Telco: siteId', this.addPropsData.siteId)
  }
}

</script>
